import React, {
  useEffect, useState, Suspense, useContext,
} from 'react';
import { Route, useNavigate } from 'react-router-dom';
import { getPortfolio, getProfile, multiCauseSubs } from '../redux/actions/Home';
import {
  appCondition, checkNonSip, checkUserValidity, fetchSubscription, getCookie, getUrlParameterByName, handleKettoLinks, handleScrollIntoSection, handleUserStatus, latestApiParams, RedirectToSignIn,
} from './helperFunctions';
import { UserLoginContext } from '../contexts/LoggedInUserContext';
import LoadPlacesScript from './gApiScriptLoad';
import Navbar from '../src/components/Common/Navbar';
import { BottomNavigationBar } from '../src/components/Common';
import Shimmer from '../src/components/Dashboard/Shimmer';
import LoadVerloopSupport from './VerloopScriptLoad';
import ClarityScriptLoad from './ClarityScriptLoad';
import CartModal from '../src/components/CartModal';

const GuardedRoute = ({
  component: Component, authRequired, isValidUser, defaultpage = false, ...rest
}, props) => {
  const [data, setData] = useState({ isValidHere: false, isWaiting: true });
  const context = useContext(UserLoginContext);
  const history = useNavigate();
  
  useEffect(() => {
    checkValidity();
    (function () {
      window.onpageshow = function (event) {
        if (event.persisted) {
          if (window.location.pathname == '/') {
            history('/sipselect');
          } else {
            window.location.reload();
          }
        }
      };
    }());
    return (() => {
      setData({ isValidHere: false, isWaiting: true });
    });
  }, [Component]);
 
  useEffect(() => {
    checkUserValidity().then((res) => {
      context.setLoggedIn(res); // Set context if user is logged in or not
    });
    window.scrollTo(0, 0);
  }, []);
  
  const checkValidity = async () => {
    LoadPlacesScript();
    LoadVerloopSupport();
    setData({ isValidHere: false, isWaiting: true });
    // ClarityScriptLoad();
    let multiId = null;
    const lapsedUserList = ['/', '/allocatefunds'];
    const standAlonePages = ['/editprofile', '/updates', '/activity', '/mydonations', '/comments', '/updatepassword', '/healthfirst', '/preferences', '/donationpreferences', '/communicationpreferences', '/referral'];
    if (window.location.search.includes('sip_cause')) {
      sessionStorage.removeItem('multiCauseId');
    } else {
      multiId = JSON.parse(sessionStorage.getItem('multiCauseId'));
    }
    let newSub = null;
    const portfolioLogic = (data1) => data1 && (data1.length == 0 || (Object.keys(data1).length == 1 && (('memorial' in data1) || ('insurance' in data1) || ('sip_protect' in data1))));
    checkUserValidity().then((res) => {
      if (!res) {
        RedirectToSignIn(true); // Redirect to Signin if token is not available
      } else {
        getProfile(context.userData, context.setUserData).then(async (response) => {
          const focusParams = getUrlParameterByName('focus');
          if (focusParams) {
            setTimeout(() => {
              handleScrollIntoSection(focusParams);
            }, 1400);
          }
          if (checkNonSip(response.listsubscriptions)) {
            // Only for app users
            if (authRequired) {
              history('/nonsipuser');
            } else {
              showComponent();
            }
          } else if (portfolioLogic(response.listsubscriptions) && !getCookie('platform')) {
            //  For M-web Non-sip user redirect to portfolio page
            if (!standAlonePages.includes(window.location.pathname)) {
              window.location.href = handleKettoLinks('new/portfolio');
            } else {
              showComponent();
            }
          } else {
            // For Sip Users
            multiCauseSubs(response?.id, response?.latest_subscription?.currency, context.multiArray, context.setMultiArray).then((res2) => {
              const multiCause = res2;
              const exploreCount = multiCause && multiCause?.filter((item) => (item.label != 'NEW'));
              if (multiId && multiId.id && multiId.cause) {
                newSub = multiCause && multiId && multiCause.find((item) => item.campaign_cause == multiId.cause);
                sessionStorage.setItem('multiCauseId', JSON.stringify({ id: newSub && newSub.id, cause: newSub && newSub.campaign_cause }));
              }
              let subData = null;
              const iosCondition = appCondition();
              if (!!getCookie('platform') && !iosCondition) {
                subData = fetchSubscription(multiCause, newSub && newSub.id);
                localStorage.setItem('multiLength', exploreCount.length > 1 ? '2' : '1');
              } else if (getUrlParameterByName('cause')) {
                const defCause = getUrlParameterByName('cause');
                const defArray = multiCause && multiCause.find((item) => item.campaign_cause == defCause);
                if (defArray && defArray.label == 'NEW' && exploreCount.length > 1) {
                  history('/sipselect');
                  return;
                }
                subData = fetchSubscription(multiCause, defArray && defArray.id);
                    
                if (!subData) {
                  subData = multiCause && multiCause.find((item) => item.campaign_cause == multiId.cause);
                }
                localStorage.setItem('multiLength', exploreCount.length > 1 ? '2' : '1');
              } else if (!multiId && exploreCount.length > 1 && !defaultpage) {
                history('/sipselect');
                showComponent();
                return;
              } else {
                subData = fetchSubscription(multiCause, newSub && newSub.id);
                if (!subData) {
                  subData = multiCause && multiCause.find((item) => item.campaign_cause == multiId.cause);
                }
                localStorage.setItem('multiLength', exploreCount.length > 1 ? '2' : '1');
              }
              const latestParam = latestApiParams(subData, multiCause);
          
              // Run latest api only for specific pages
              const checkPages = ['/editprofile', '/updatepassword'];
              if (!checkPages.includes(window.location.pathname)) {
                getPortfolio(latestParam && latestParam.id, latestParam && latestParam.cause).then((res3) => {
                  const latestOrder = res3;
                  if (latestOrder && (latestOrder.status_flag == 2 || latestOrder.status_flag == 4 || latestOrder.status_flag == 5)) {   
                    if (lapsedUserList.includes(window.location.pathname)) {
                      // if user is not on allowed inactive pages redirect to anactive landing page and avoid rendering and api calls
                      const sip_Cause = getUrlParameterByName('cause');
                      history(sip_Cause ? `/inactiveuser?cause=${sip_Cause}` : '/inactiveuser');
                      sessionStorage.setItem(
                        'isInactive',
                        handleUserStatus(latestOrder.status_flag),
                      );
                    } else {
                      // turn off waiting flags to allow rendering of UI
                      showComponent();
                    }
                  } else if (latestOrder && (latestOrder.status_flag == 1)) {
                    sessionStorage.removeItem('isInactive');
                    showComponent();
                  }
                  context.setLatestOrder(latestOrder);
                });
              } else {
                showComponent();
              }
            });
          }
          // context.setUserData(response);
        });
      }
    });

    localStorage.removeItem('animalPopUp');
  };
 
  const showComponent = () => {
    const temp = { isValidHere: true, isWaiting: false };
    setData({ ...temp });
  };

  const handleInvalidUser = () => {
    // RedirectToSignIn(true);
  };
  const isAppUser = getCookie('platform');
  const isMulti = window.location.pathname !== '/sipselect';
  const hideCart = JSON.parse(sessionStorage.getItem('hideCart'));
  const urlArrays = ['/', '/sipselect', '/healthfirst', '/healthfirstplans'];
  const isHome = urlArrays.includes(window.location.pathname);

  return (
    <>
 
      {!isAppUser && isMulti && <Navbar />}
      {/* {data.isWaiting && } */}

      {!data.isWaiting && data.isValidHere === true ? (
        <>
          <Suspense fallback={<div><Shimmer /></div>}>
            <Component {...props} />
          </Suspense>
        </>
      ) : (
        <Shimmer />
      )}
      {!isHome && !isAppUser && <CartModal />}
      {!isAppUser && isMulti && <BottomNavigationBar />}
    </>
  );
};
export default GuardedRoute;
